/**
 * Copyright (C) 2018 Frontier Developments PLC.
 */

/**
 * Provide a local storage abstraction service.
 *
 * Service allows scope name change by passing 'name' in config parameter.  In the example below this would place
 * $someOtherName in the Vue instance - so from within a component we would use: this['$someOtherName']
 * e.g. Vue.use(Debounce, {name: 'someOtherName'})
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

function install(Vue: any, options: any = {}): void {
    (window as any)['debounce'] = require('debounce');

    // determine if the client supports debounce
    const isSupported: boolean = !!(window as any)['debounce'];

    const name: string = 'debounce';

    Vue.mixin({
        beforeCreate(): void {
            if (!isSupported) {
                return;
            }
        },
    });

    Vue[name] = (window as any)['debounce'];
    Vue.prototype[`$${name}`] = (window as any)['debounce'];
}

export default install;
